<div class="row">
  <div class="col-lg-12">
    <div class="card" id="costumers-contatctsList">
      <div class="card-header border-0">
        <div class="row g-4 align-items-center">
          <div class="col-sm-3" *ngIf="totalAuxCostumers > 0 || totalAuxOwners > 0">
            <div class="search-box" [class.placeholder-glow]="hideElement">
              <input type="text" name="searchTerm" class="form-control"
                [attr.placeholder]="!hideElement ? 'Search for name, email...': ''" [formControl]="queryField"
                [class.placeholder]="hideElement" [attr.disabled]="hideElement ? true : null">

              <i class="ri-search-line search-icon" *ngIf="!hideElement"></i>
            </div>
          </div>

          <div class="col-sm-auto ms-auto d-none">
            <div class="hstack gap-2" [class.placeholder-glow]="hideElement">
              <button class="btn btn-soft-danger" (click)="deleteMultiple()" id="btn-delete-contact-property"
                [class.placeholder]="hideElement" [attr.disabled]="countCheckSelected == 0 ? true: null">
                <i class="ri-delete-bin-2-line"></i>
              </button>

              <button type="button" class="btn btn-outline-primary waves-effect waves-primary add-btn"
                id="btn-add-contact-property" (click)="openModal()" [class.placeholder]="hideElement"
                [attr.disabled]="hideElement ? true: null">
                <i class="ri-add-line align-bottom me-1"></i>

                {{textAddContact}}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- WARNING -->
      <div class="owners-warning-wrap">
        <div *ngIf="showOwnersWarningBanner" class="owners-warning-banner" role="alert">
          <span class="owners-warning-icon" aria-hidden="true">
            <i class="ri-error-warning-fill"></i>
          </span>

          <div class="owners-warning-content">
            <p class="owners-warning-title mb-0">
              {{ 't-required-owner' | translate }}
            </p>

            <small class="owners-warning-subtitle">
              {{ 't-m-properties.t-is-mandatory-to-activate-the-property' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div>
          <div class="table-responsive table-card" *ngIf="contacts && total > 0">
            <table class="table">
              <thead>
                <tr class="bg-light text-muted">
                  <th scope="col" style="width: 50px;">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="checkAll" value="option"
                        [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)">
                    </div>
                  </th>

                  <th style="width: 20%">{{'t-name' | translate}}</th>
                  <th>{{'t-email' | translate}}</th>
                  <th style="width: 20%">{{'t-phone' | translate}}</th>
                  <th style="width: 20%;">{{'t-status' | translate}}</th>
                  <th style="width: 5%">
                    {{'t-action' | translate}}
                  </th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let contact of contacts">
                  <tr *ngIf="contact.isAddToProperty">
                    <th scope="row">
                      <div class="form-check"
                        *ngIf="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || contact.isNew || !property">
                        <input class="form-check-input" type="checkbox" name="checkAll" value="option1"
                          [(ngModel)]="contact.isSelected" (change)="checkUncheck($event, contact)">
                      </div>
                    </th>

                    <td>
                      <div class="d-flex align-items-left">
                        <div class="flex-shrink-0" style="margin-right: 10px;">
                          <img [src]="'assets/images/users/user-dummy-img.jpg'" alt="profile"
                            class="avatar-xxs rounded-circle image_src object-cover" />
                        </div>

                        <div class="flex-grow-1 ms-2 name">
                          {{ contact.firstName }} {{ contact.lastName }}
                        </div>
                      </div>
                    </td>

                    <td class="email_id">
                      {{contact.email}}
                    </td>

                    <td>
                      {{contact.phoneNumber1 ?? contact?.phoneNumber}}
                    </td>

                    <td>
                      <div class="d-flex align-items-center" *ngIf="contact.status">
                        <div class="flex-grow-1">
                          <i class="ri-checkbox-circle-line align-middle text-success"></i>
                          {{'t-active' | translate}}
                        </div>
                      </div>

                      <div class="d-flex align-items-center" *ngIf="!contact.status">
                        <div class="flex-grow-1">
                          <i class="ri-close-circle-line align-middle text-danger"></i>
                          {{'t-inactive' | translate}}
                        </div>
                      </div>
                    </td>

                    <td>
                      <ul class="list-inline hstack gap-2 mb-0"
                        *ngIf="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) || contact.isNew || !property">
                        <li class="list-inline-item" ngbTooltip="{{'t-delete' | translate}}" placement="top">
                          <a class="remove-item-btn text-danger cursor-pointer" (click)="confirm(contact)">
                            <i class="ri-delete-bin-fill align-bottom"></i>
                          </a>
                        </li>

                        <li></li>
                      </ul>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div class="row justify-content-md-between align-items-md-center mt-3" *ngIf="total > 0">
            <div class="col col-sm-6">
              <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                {{'t-showing' | translate}}
                {{startIndex}} {{'t-table-to' | translate}}
                {{endIndex}} {{'t-table-of' | translate}} {{total}}
                {{'t-table-entries' | translate}}
              </div>
            </div>

            <!-- Pagination -->
            <div class="col col-sm-6">
              <div class="text-sm-right float-sm-end listjs-pagination">
                <ngb-pagination [maxSize]="6" [collectionSize]="(total)" [(page)]="page" [pageSize]="pageSize"
                  (pageChange)="refreshContacts()">
                </ngb-pagination>
              </div>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>

      <div class="py-4 text-center" *ngIf="noresult">
        <div>
          <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
            colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
          </lord-icon>
        </div>

        <div class="mt-4">
          <h5>{{'t-no-result-message' | translate}}</h5>
        </div>
      </div>

      <app-spinner></app-spinner>
    </div>
  </div>
</div>

<app-create-edit-contacts></app-create-edit-contacts>